export default __webpack_public_path__ + "static/media/post.c0102084.svg";